<template>
    <div class="new-chat-tabs">
        <button
            class="button button_size_small new-chat-tabs__btn"
            :class="{ 'button_color_black': selected === 'common' }"
            @click="$emit('click', 'common')"
        >
            Все чаты
        </button>
        <button
            class="button button_size_small new-chat-tabs__btn"
            :class="{ 'button_color_black': selected === 'personal' }"
            @click="$emit('click', 'personal')"
        >
            Мои чаты
            <span v-if="unreadMyChats > 0" class="new-chat-tabs__badge">{{ unreadMyChats }}</span>
        </button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'NewChatTabs',
    props: {
        selected: {
            type: String,
            default: 'common'
        }
    },
    computed: {
        ...mapGetters('newChat', ['unreadMyChats'])
    }
}
</script>

<style scoped lang="scss">
.new-chat-tabs__btn {
    display: inline-flex;
    align-items: center;
    gap: 5px;
}

.new-chat-tabs__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    padding: 0 5px;
    border-radius: 9px;
    background-color: #e53935;
    color: #fff;
    font-size: 11px;
    font-weight: 600;
    line-height: 1;
}
</style>
